import { pascalize, decamelize } from 'humps'
import { getProductDetailByPropertyName, PRODUCT_NAME_VARIATION_TYPES } from './cfs-card'

export function safeStringify(obj) {
  try {
    return JSON.stringify(obj)
  } catch (err) {
    return ''
  }
}

export function getUserCountryCode(req) {
  return (req.locality?.country || '').toLowerCase()
}

export function formatUniversalLinkProductName(productName) {
  const systemProductName = getProductDetailByPropertyName(
    productName,
    PRODUCT_NAME_VARIATION_TYPES.ALIAS,
  )?.system

  if (!systemProductName) return productName

  return pascalize(systemProductName.toLowerCase())
}

export function formatUniversalLinkProductNameToSystem(productName) {
  const uLinkProductName = formatUniversalLinkProductName(productName)
  return decamelize(uLinkProductName).toUpperCase()
}
